
const CONSTANT = require('./constant')

const bridge = require('./wgwebbridge')

export const BASE_URL = CONSTANT.BASE_URL

export const mode = window.location.href.indexOf('#/') !== -1 ? 'hash' : 'history'

export const wgweb = bridge.wgweb
